import React from "react";
import { parseISO } from "date-fns";
import {
  localizedFormatDate,
  localizedFormatDateTime,
} from "helpers/userLocale";
import { GuaranteeStatus } from "./GuaranteesViewPanel";
import { GuaranteeViewData } from "./GuaranteeDataModel";

//icons
import PendingIcon from "../../assets/Icon_State_01.png";
import ApprovedIcon from "../../assets/Icon_State_04.png";
import DeclinedIcon from "../../assets/Icon_State_05.png";
import LockedIcon from "../../assets/Icon_State_02.png";
import ReleasedIcon from "../../assets/Icon_State_03.png";
import ReleasingIcon from "../../assets/Icon_State_06.png";

type Props = {
  details: GuaranteeViewData;
  status?: GuaranteeStatus | string;
  report:boolean;
};

const GuaranteePanelHeader: React.FC<Props> = ({ details, report=false }) => {
  const status = details.status?.toLowerCase();
  const getGuaranteeStatusIcons = () => {
    switch (status) {
      case "pending":
        return PendingIcon;
      case "declined":
        return DeclinedIcon;
      case "approved":
        return ApprovedIcon;
      case "locked":
        return LockedIcon;
      case "released":
        return ReleasedIcon;
      case "releasing":
        return ReleasingIcon;
      default:
        return "";
    }
  };

  const getGuaranteeStatusBackground = () => {
    switch (status) {
      case "pending":
        return "#e3effb";
      case "approved":
        return "#e3effb";
      case "declined":
        return "#e3effb";
      case "locked":
        return "#fff7f7";
      case "released":
        return "#f4fef2";
      default:
        return "#f5f5f5";
    }
  };
  return (
    <div className="ViewSection">
      <div className="GuaranteeStatus">
      <div
        className="ImageContainer"
        style={{ backgroundColor: getGuaranteeStatusBackground() }}
      >
        {getGuaranteeStatusIcons() ? (
          <img className="imgSt" src={getGuaranteeStatusIcons()} alt="Guarantee Status" />
        ) : (
          status
        )}
      </div>
      </div>
      <div className="GuaranteeDetails">
        <div className="Header">
          <div>
            <span className="Ammount">{details.guaranteeAmount}</span>{" "}
            <span className="Currency">{details.assetsCode}</span>
          </div>
          {details.guestReference && (
            <div>
              <span className="ReferenceLabel">Guest Reference:</span>{" "}
              <span className="Reference">{details.guestReference}</span>
            </div>
          )}
        </div>
        <div className={`Details ${report?'increase-font':''}`}>
          <h2>{`${details.verifiedGivenNames ??
            ""} ${details.verifiedLastName ?? ""}`}</h2>
          {(status === "pending" || status === "approved") && (
            <div className="DetailsContainer">
              <div className="Section">
                <div>
                  <span>Start date:</span>
                  <span>
                    {details.startDate &&
                      localizedFormatDate(parseISO(details.startDate))}
                  </span>
                </div>
              </div>
            </div>
          )}

          {status === "declined" && (
            <div className="DetailsContainer">
              <div className="Section" style={{ width: "100%" }}>
                <div>
                  <span>Start date:</span>
                  <span>
                    {details.startDate &&
                      localizedFormatDate(parseISO(details.startDate))}
                  </span>
                </div>
                <div>
                  <span>Declined reason: {details.declineReason ?? ""}</span>
                  <span></span>
                </div>
              </div>
            </div>
          )}

          {status === "locked" && (
            <div className="DetailsContainer">
              <div className="Section">
                <div>
                  <span>Date locked:</span>
                  <span>
                    {details.dateLocked &&
                      localizedFormatDate(parseISO(details.dateLocked))}
                  </span>
                </div>
                <div>
                  <span>Locked by:</span>
                  <span>{details.lockedBy}</span>
                </div>
                <div>
                  <span>IP address:</span>
                  <span>{details.lockedByIp}</span>
                </div>
                <div>
                  <span>Start date:</span>
                  <span>
                    {" "}
                    {details.startDate &&
                      localizedFormatDate(parseISO(details.startDate))}
                  </span>
                </div>
              </div>
            </div>
          )}
          {(status === "released" || status === "releasing") && (
            <div className="DetailsContainer">
              <div className="Section">
                <div>
                  <span>Date locked:</span>
                  <span>
                    {details.dateLocked &&
                      localizedFormatDate(parseISO(details.dateLocked))}
                  </span>
                </div>
                <div>
                  <span>Locked by:</span>
                  <span>{details.lockedBy}</span>
                </div>
                <div>
                  <span>Locked IP address:</span>
                  <span>{details.lockedByIp}</span>
                </div>
                <div>
                  <span>Start date:</span>
                  <span>
                    {" "}
                    {details.startDate &&
                      localizedFormatDate(parseISO(details.startDate))}
                  </span>
                </div>
              </div>
              <div className="Section">
                <div>
                  <span>Date unlocked:</span>
                  <span>
                    {details.dateUnLocked &&
                      localizedFormatDate(parseISO(details.dateUnLocked))}
                  </span>
                </div>
                <div>
                  <span>Unlocked by:</span>
                  <span>{details.unLockedBy}</span>
                </div>
                {details.unLockedByIp && (
                  <div>
                    <span>Unlocked IP address:</span>
                    <span>{details.unLockedByIp}</span>
                  </div>
                )}
              </div>
            </div>
          )}

          <div></div>
        </div>
      </div>
    </div>
  );
};

export default GuaranteePanelHeader;
